import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-test-cpt',
  templateUrl: './test-cpt.component.html',
  styleUrl: './test-cpt.component.scss'
})
export class TestCptComponent implements OnInit {
  @Input() data :any;
  @Output() removeCptCode = new EventEmitter<any>();
  @Output() updateData = new EventEmitter<any>();
  testAttributes: any = [];
  cptCodeAttributes: any = [];
  constructor(){
  }

  ngOnInit(): void {
    console.log('Test CPT data', this.data);

   // this.testAttributes.push({Name: 'Name', value: this.data.Test[0].Name});
    Object.entries(this.data).forEach(([key, value]) => {
      console.log(`${key} ${value}`);
      this.testAttributes.push({name: key, value: value});
    });
    console.log("this.testAttributes", this.testAttributes);
  }

  testModel(){
    console.log("testModel", this.data);
  }

  removeCPTCode(field){
    console.log("removeCPTCode", field);
    this.removeCptCode.emit(field);
    this.updateData.emit(this.data);
  }
}
